import { randomNumber } from '../../utilities'
import { NumberPadConstants } from './numberPad.constants'

export default class NumberPadItem {
  key: string
  dataTestId: string
  char: string
  color: string
  expand: 'block' | 'full' | undefined
  className: string

  private static _INTERNAL_CHAR_TO_DATA_TEST_ID_MAP: Map<string, string> = new Map()

  constructor(char: string, color = 'light', expand: 'block' | 'full' | undefined = 'block', className = 'ion-button') {
    this.key = randomNumber().toString()

    const testId = NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.get(char)
    if (!testId) {
      throw new Error(`The displayChar [${char}] does not have a data test id mapping`)
    }

    this.dataTestId = testId
    this.char = char
    this.color = color
    this.expand = expand
    this.className = className
  }

  static initialize(): void {
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('1', NumberPadConstants.NUMBER + 'One')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('2', NumberPadConstants.NUMBER + 'Two')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('3', NumberPadConstants.NUMBER + 'Three')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('4', NumberPadConstants.NUMBER + 'Four')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('5', NumberPadConstants.NUMBER + 'Five')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('6', NumberPadConstants.NUMBER + 'Six')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('7', NumberPadConstants.NUMBER + 'Seven')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('8', NumberPadConstants.NUMBER + 'Eight')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('9', NumberPadConstants.NUMBER + 'Nine')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('0', NumberPadConstants.NUMBER + 'Zero')

    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('P', NumberPadConstants.NUMBER + 'P')

    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('.', NumberPadConstants.NUMBER + 'DecimalPoint')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('*', NumberPadConstants.NUMBER + 'Asterisk')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('-', NumberPadConstants.NUMBER + 'Hyphen')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set('#', NumberPadConstants.NUMBER + 'HashSign')
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set(':', NumberPadConstants.NUMBER + 'Ratio')

    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set(NumberPadConstants.BACKSPACE, NumberPadConstants.BACKSPACE)
    NumberPadItem._INTERNAL_CHAR_TO_DATA_TEST_ID_MAP.set(
      NumberPadConstants.EMPTY,
      NumberPadConstants.NUMBER + NumberPadConstants.EMPTY
    )
  }
}
